import { Avatar } from '@aimsos/ui';

/**
 * Sizing overrides follow the repo's convention for `Avatar` (see
 * `admin-studio/.../requesterAvatarClass.js`): `!h/!w/!min-h/!min-w` because
 * `Avatar` always applies one of its own five `size` presets, and `!rounded-xl`
 * because `rounded-full` is generated after `rounded-xl` in the Tailwind sheet.
 * The design calls for a rounded SQUARE tile, not a circle.
 */
const VARIANT_CLASSES = {
  hero: '!h-12 !w-12 !min-h-[3rem] !min-w-[3rem] [&>span]:text-base',
  compact: '!h-10 !w-10 !min-h-[2.5rem] !min-w-[2.5rem] [&>span]:text-sm',
};

/**
 * Workspace logo, or a colored initials tile when there is no logo.
 *
 * Built on `@aimsos/ui`'s `Avatar` (initials variant), fed the workspace's own
 * `initials` from `services/workspaces.js` (`deriveInitials`). The accent
 * classes come from the mock metadata and always pair a light-theme text shade
 * with a `dark:` one, so the initials stay readable in both themes.
 */
function WorkspaceInitialsAvatar({ src, initials, name, accentClassName = '', variant = 'compact' }) {
  return (
    <Avatar
      // The workspace's own logo when the API has one (`profilePhotoUrl` ->
      // `avatarSrc`); `Avatar` falls back to the initials on its own when
      // `src` is absent, so both paths go through one component.
      src={src}
      initials={initials || 'WS'}
      alt={name}
      className={[
        VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.compact,
        '!rounded-xl !border-0 bg-surface-elevated font-semibold ring-1',
        accentClassName,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}

export default WorkspaceInitialsAvatar;
